export const generateQuery = (params) => {
  const filteredParams = Object.fromEntries(Object.entries(params).filter(([key, value]) => value != null));
  return new URLSearchParams(filteredParams).toString();
};

export function generateUrl({ url, query }) {
  if (!query || Object.values(query).filter(Boolean).length === 0) {
    return url;
  }
  return `${url}?${generateQuery(query)}`;
}

export const updateUrlParameter = ({ url, key, value }) => {
  // remove the hash part before operating on the uri
  const i = url.indexOf('#');
  const hash = i === -1 ? '' : url.substr(i);
  url = i === -1 ? url : url.substr(0, i);

  const re = new RegExp(`([?&])${key}=.*?(&|$)`, 'i');
  const separator = url.indexOf('?') !== -1 ? '&' : '?';

  if (value === null) {
    // remove key-value pair if value is specifically null
    url = url.replace(new RegExp(`([?&]?)${key}=[^&]*`, 'i'), '');
    if (url.slice(-1) === '?') {
      url = url.slice(0, -1);
    }
    // replace first occurrence of & by ? if no ? is present
    if (url.indexOf('?') === -1) url = url.replace(/&/, '?');
  } else if (url.match(re)) {
    url = url.replace(re, `$1${key}=${value}$2`);
  } else {
    url = `${url + separator + key}=${value}`;
  }
  return url + hash;
};

export function extractMerchantSlugFromUrl() {
  const urlParts = window.location.host.split('.').filter((p) => p.toLowerCase() !== 'www');
  const domainParts = urlParts.slice(0, -2); // Remove the top-level domain

  return domainParts[0] || null;
}
